var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.tableData,"pagination":_vm.pagination,"row-key":function (record) { return record.deviceId; },"loading":_vm.loading},on:{"change":_vm.handlePagination}})}
var staticRenderFns = []

export { render, staticRenderFns }